import React from "react";
import { Tooltip } from "@material-ui/core";
import {
  DataSourceModelDict,
  OnlyStateDic,
} from "../../../../../store/datasources/types";
import Loader from "../../../../atoms/Loader";
import { ListContainer, ListItemContainer } from "./styles";
import { StateIndicator } from "../../../../atoms/DataSourceState/styles";

export type ListOfDataSourcesProps = {
  dataSources: DataSourceModelDict;
  dataSourcesState: OnlyStateDic;
  mappedDataSources: number[];
  toggled: boolean;
  isLoading: boolean;
};

const ListOfDataSources = ({
  dataSources,
  dataSourcesState,
  mappedDataSources,
  toggled,
  isLoading,
}: ListOfDataSourcesProps) => {
  const listOfIdsToShow = toggled
    ? mappedDataSources
    : mappedDataSources.slice(0, 2);

  const showDataSource = (dataSourceId: number) => {
    const state = dataSourcesState[dataSourceId];
    const { name } = dataSources[dataSourceId];

    if (!state) return <Loader size={24} />;

    if (!state?.data) {
      return null;
    }

    const { serverState, error } = state.data;

    return (
      <ListItemContainer key={dataSourceId}>
        <Tooltip title={serverState === "online" ? serverState : error}>
          <StateIndicator state={serverState} size={14} />
        </Tooltip>
        <span>{name}</span>
      </ListItemContainer>
    );
  };

  return <ListContainer>{listOfIdsToShow.map(showDataSource)}</ListContainer>;
};

export default ListOfDataSources;
